import { Injectable, inject } from '@angular/core';
import { OrganizationProjectsService, OrganizationService, OrganizationUsersService } from '../../services/organization.service';
import { ProjectService, ProjectUsersService } from '../../services/project.service';
import { loadWorkspace } from './workspace.load';
import { WorkspaceLoadPayload } from './workspace.actions';

/**
 * Thin injectable wrapper over the pure `loadWorkspace` function so effects can
 * depend on it via DI (and tests can mock it cleanly — no module-namespace spying).
 */
@Injectable({ providedIn: 'root' })
export class WorkspaceLoaderService {
  private projectUsers = inject(ProjectUsersService);
  private orgUsers = inject(OrganizationUsersService);
  private orgProjects = inject(OrganizationProjectsService);
  private projects = inject(ProjectService);
  private organizations = inject(OrganizationService);

  load(): Promise<WorkspaceLoadPayload> {
    return loadWorkspace({
      projectUsers: this.projectUsers,
      orgUsers: this.orgUsers,
      orgProjects: this.orgProjects,
      projects: this.projects,
      organizations: this.organizations,
    });
  }
}
